import axios from 'axios';
import Cookies from 'universal-cookie';
import ReactDOM from 'react-dom/client';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import Slider from "react-slick";
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CartCheckFill, Filter, Truck } from 'react-bootstrap-icons';
import { Row, Col, Container, Form, Pagination, Card, Button, Spinner, Offcanvas, Accordion, Modal, InputGroup } from 'react-bootstrap';

const CatalogoHUjueta = () => {
    const navigate = useNavigate();
    const Location = useLocation();
    const cookies = new Cookies();
    const [cantidad, setCantidad] = useState(1);
    const [objItem, setObjItem] = useState(null);
    const [tituloMensaje, setTituloMensaje] = useState(null);
    const [validacionAgregarCarrito, setValidacionAgregarCarrito] = useState(false);
    const [showModalAgregar, setShowModalAgregar] = useState(false);
    const [showCategorias, setShowCategorias] = useState(false);
    const [showCanvasCategorias, setShowCanvasCategorias] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [rangoFinal, setRangoFinal] = useState(12);
    const [productos, setProductos] = useState([]);
    const [totalPaginas, setTotalPaginas] = useState(0);
    const [filtroProductos, setFiltroProductos] = useState([]);
    const [arrayCategorias, setArrayCategorias] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [tituloBusqueda, setTituloBusqueda] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const [listaPrecios, setListaPrecios] = useState('014');
    const imagenPublicidad = process.env.REACT_APP_SERVER_IMAGE + 'estaticas/';

    var settingsMarcas = {
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 620,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const arrayMarcas = [
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/ELITE.png',
            nombre: 'Marca 14'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/FURIUS.png',
            nombre: 'Marca 15'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/SIEFKEN.png',
            nombre: 'Marca 16'
        },
        {
            imagen: process.env.REACT_APP_SERVER_IMAGE + 'marcas/SWEISS.png',
            nombre: 'Marca 17'
        },
    ];

    const handleCategoryChange = (categoria) => {
        let categoriasAux = [];
        if (categorias.includes(categoria)) {
            categoriasAux = categorias.filter((c) => c !== categoria);
        } else {
            categoriasAux = [categoria];
        }
        setCategorias(categoriasAux);
        if (categoriasAux.length > 0) {
            const filtroCategoria = productos.filter((producto) =>
                categoriasAux.some((categoria) => producto.category === categoria)
            );
            setFiltroProductos(filtroCategoria);
            setTotalPaginas(1);
        } else {
            const paginaInicio = (paginaActual - 1) * rangoFinal;
            const paginaFinal = paginaInicio + rangoFinal;
            setFiltroProductos(productos.slice(paginaInicio, paginaFinal));
            setTotalPaginas(Math.ceil(productos.length / rangoFinal));
        }
        setShowCanvasCategorias(false)
    };

    const formatoPesosColombianos = useMemo(() => {
        return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 0,
        });
    }, []);

    const handleRangoFinal = useCallback((e) => {
        setRangoFinal(parseInt(e.target.value));
    }, []);

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        setTituloBusqueda('');
        const cookies = new Cookies();
        const accessToken = cookies.get('accesToken');
        const urlCliente = process.env.REACT_APP_SERVER + '/api/v1/validarListaPrecio';
        const respCliente = await axios.get(urlCliente, {
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        });
        const { data } = await axios.get(process.env.REACT_APP_SERVER + '/api/v1/items/ujueta/list', {
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        });
        if (data.result) {
            const resultProductos = data.productos;
            if (respCliente.data.lista_de_precios === '001') {
                const { data: resultCategorias } = await axios.get(process.env.REACT_APP_SERVER + '/api/v1/items/ujueta/sublineas/list', {
                    headers: {
                        "Authorization": `Bearer ${accessToken}`
                    }
                });
                for (let i = 0; i < resultProductos.length; i++) {
                    const product = resultProductos[i];
                    let descuento = 0;
                    const buscarCategoria = resultCategorias.categorias.find(
                        (categoria) => categoria.descripcion_categoria.toUpperCase() === product.category.toUpperCase()
                    );
                    if (buscarCategoria) {
                        descuento = buscarCategoria.descuento_categoria;
                    }
                    resultProductos[i] = { ...resultProductos[i], descuento: descuento };
                }
            }
            setProductos(resultProductos);
            setTotalPaginas(Math.ceil(resultProductos.length / rangoFinal));
            setIsLoading(false);
            setShowCategorias(true);
        }

    }, [rangoFinal]);

    const handlePagination = useCallback((pagina) => {
        setPaginaActual(pagina);
        window.scroll(0, 0);
    }, []);

    const generatePageNumbers = useCallback(() => {
        const numerosPagina = [];
        const paginaInicio = Math.max(1, paginaActual - 2);
        const paginaFinal = Math.min(totalPaginas, paginaInicio + 4);
        for (let i = paginaInicio; i <= paginaFinal; i++) {
            numerosPagina.push(i);
        }
        return numerosPagina;
    }, [paginaActual, totalPaginas]);

    const validacionAgregarProducto = async (propiedades) => {
        try {
            let token = cookies.get('accesToken');
            let objItemAux = '';
            const url = process.env.REACT_APP_SERVER + '/requireAuth/routes';
            const response = await axios.get(url, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const data = response.data;
            if (data.validation === 1) {
                let descuento = 0;
                listaPrecios === '001' && (descuento = propiedades.descuento);
                objItemAux = {
                    item: propiedades.sku,
                    descripcion: propiedades.name,
                    um: 'UND',
                    precio: parseInt((propiedades.price * 1.19) * (1 - parseFloat(descuento) / 100)),
                    descuento_original: 0,
                    descuento: 0,
                    valor_final: parseInt((propiedades.price * 1.19) * (1 - parseFloat(descuento) / 100))
                };
            }
            setCantidad(1);
            setTituloMensaje("");
            setObjItem(objItemAux);
            setValidacionAgregarCarrito(true);
        } catch (err) {
            console.log(err);
            if (err.response.status === 403 ||
                err.response.status === 401) {
                setTituloMensaje("Información");
            }
        }
        setShowModalAgregar(true);
    }

    const registrarProductoCarrito = async () => {
        const token = cookies.get('accesToken');
        const user = cookies.get('user');
        if (cantidad % 1 !== 0) {
            alert('La cantidad debe ser un número entero')
        } else if (cantidad <= 0) {
            alert('La cantidad debe ser mayor a 0')
        } else {
            try {
                const urlRegistrar = process.env.REACT_APP_SERVER + '/api/v1/shoppingCart/register';
                const body = { cantidad, objItem, sobrePedido: 'SI', lugar: 'catalogoUjueta' };
                const responseRegistrar = await axios.post(urlRegistrar, body, {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                });
                const dataRegistrar = responseRegistrar.data;
                setShowModalAgregar(false);
                cookies.set('accesToken', dataRegistrar["accessToken"], { path: '/' });
                const urlCarrito = process.env.REACT_APP_SERVER + '/api/v1/shoppingCart/list';
                const responseCarrito = await axios.get(urlCarrito, {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                });
                const dataCarrito = responseCarrito.data[0];
                cookies.set('carrito', (dataCarrito.length));
                if (user.tipo_usuario === 'temporal') {
                    const root = ReactDOM.createRoot(
                        document.getElementById('numberCarTemporal')
                    );
                    const element = <span className="badge badge-dark">{cookies.get('carrito')}</span>
                    root.render(element);
                } else {
                    const root = ReactDOM.createRoot(
                        document.getElementById('numberCar')
                    );
                    const element = <span className="badge badge-dark">{cookies.get('carrito')}</span>
                    root.render(element);
                }
            } catch (err) {
                console.log(err);
                if (err.response.status === 403 ||
                    err.response.status === 401) {
                    setTituloMensaje("Información");
                }
            }
        }
    }

    useEffect(() => {
        setPaginaActual(1);
        const validacionInicial = async () => {
            const cookies = new Cookies();
            const accessToken = cookies.get('accesToken');
            const urlCliente = process.env.REACT_APP_SERVER + '/api/v1/validarListaPrecio';
            const respCliente = await axios.get(urlCliente, {
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            });
            setListaPrecios(respCliente.data.lista_de_precios);
            if (respCliente.data.tipo_cliente_pagina === 'CATALOGO') {
                navigate('/inicioSesion', { state: { page: '/catalogoUjueta' } });
            } else {
                const { data: resultFiltroCategorias } = await axios.get(process.env.REACT_APP_SERVER + '/api/v1/items/ujueta/sublineas/listDistinct', {
                    headers: {
                        "Authorization": `Bearer ${accessToken}`
                    }
                });
                if (resultFiltroCategorias.result) {
                    setArrayCategorias(resultFiltroCategorias.categorias);
                }
                if (cookies.get('textoBuscar') !== undefined) {
                    setTituloBusqueda(cookies.get('textoBuscar'));
                    if (Location.state !== null) {
                        if (Location.state.searchType === 'Ujueta') {
                            setShowCategorias(false);
                            if (Location.state.limitPags > 0) {
                                const { data } = Location.state
                                if (respCliente.data.lista_de_precios === '001') {
                                    const { data: resultCategorias } = await axios.get(process.env.REACT_APP_SERVER + '/api/v1/items/ujueta/sublineas/list', {
                                        headers: {
                                            "Authorization": `Bearer ${accessToken}`
                                        }
                                    });
                                    for (let i = 0; i < data.length; i++) {
                                        const product = data[i];
                                        let descuento = 0;
                                        const buscarCategoria = resultCategorias.categorias.find(
                                            (categoria) => categoria.descripcion_categoria.toUpperCase() === product.category.toUpperCase()
                                        );
                                        if (buscarCategoria) {
                                            descuento = buscarCategoria.descuento_categoria;
                                        }
                                        data[i] = { ...data[i], descuento: descuento };
                                    }
                                }
                                setProductos(data);
                                setFiltroProductos(data);
                            } else {
                                setProductos([]);
                                setFiltroProductos([]);
                            }
                            setTotalPaginas(Math.ceil(Location.state.limitPags / rangoFinal));
                        } else {
                            fetchData(respCliente.data.lista_de_precios);
                        }
                    } else {
                        fetchData(respCliente.data.lista_de_precios);
                    }
                } else {
                    fetchData(respCliente.data.lista_de_precios);
                }
            }
        }
        validacionInicial();
        // eslint-disable-next-line
    }, [Location.state, fetchData]);

    useEffect(() => {
        const paginaInicio = (paginaActual - 1) * rangoFinal;
        const paginaFinal = paginaInicio + rangoFinal;
        setFiltroProductos(productos.slice(paginaInicio, paginaFinal));
    }, [productos, rangoFinal, paginaActual]);

    const isMobile = window.innerWidth <= 768 ? '-movil' : '';

    return (
        <>
            <Header />
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '110%',
                    backgroundImage: `url(${imagenPublicidad}fondo-hujueta${isMobile}.webp)`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    zIndex: -1,
                }}
            />
            <br></br>
            <Container className="containerCatalogoUjueta">
                <Row>
                    <Col sm={tituloBusqueda === '' ? 3 : 12} xs={12} >
                        <Row>
                            <Col xs={12}>
                                <div style={{ height: '100px', width: '100%' }}>
                                    <img loading='lazy' fallback={<p>Cargando</p>} src={imagenPublicidad + 'logo-catalogo-hujueta.png'} alt="bannerPrincipal" className="img-fluid" />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6} sm={7} md={tituloBusqueda === '' ? 12 : 3} lg={tituloBusqueda === '' ? 5 : 3} className="mb-2">
                                <Form.Select size="sm" onChange={handleRangoFinal} value={rangoFinal} className={'filtroSelect'}>
                                    <option value={12}>{12}</option>
                                    <option value={24}>{24}</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        {showCategorias &&
                            <Row>
                                <br></br>
                                <Col className={'divCanvas'}>
                                    <div id="divOffcanvasCategorias">
                                        <Button variant="outline-warning" onClick={() => setShowCanvasCategorias(true)} style={{ margin: '10px 0px', fontSize: '16px' }}>
                                            <Filter /> Filtrar
                                        </Button>
                                        <Offcanvas show={showCanvasCategorias} onHide={() => setShowCanvasCategorias(false)}>
                                            <Offcanvas.Header closeButton />
                                            <Offcanvas.Body>
                                                <Accordion >
                                                    <Accordion.Item eventKey="0" >
                                                        <Accordion.Header className={'headerAcordion'}><h5 className='h5_titulosMenu' style={{ width: '100%' }}>CATEGORIAS DE PRODUCTOS</h5></Accordion.Header>
                                                        <Accordion.Body>
                                                            <Form>
                                                                {arrayCategorias.map((categoria, index) => (
                                                                    <Form.Check
                                                                        key={index}
                                                                        type="checkbox"
                                                                        label={categoria.category.toUpperCase()}
                                                                        checked={categorias.includes(categoria.category)}
                                                                        onChange={() => handleCategoryChange(categoria.category)}
                                                                    />
                                                                ))}
                                                            </Form>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </Offcanvas.Body>
                                        </Offcanvas>
                                    </div>
                                    <div id="divAccordionCategorias">
                                        <Accordion>
                                            <Accordion.Item>
                                                <Accordion.Header className={'headerAcordion'}><h5 className='h5_titulosMenu' style={{ height: '35px', width: '100%' }}>CATEGORIAS DE PRODUCTOS</h5></Accordion.Header>
                                                <Accordion.Body className='ps-0'>
                                                    <Form>
                                                        {arrayCategorias.map((categoria, index) => (
                                                            <Form.Check type="checkbox" key={index} className='ms-2'>
                                                                <Form.Check.Input type='checkbox' checked={categorias.includes(categoria.category)}
                                                                    onChange={() => handleCategoryChange(categoria.category)} />
                                                                <Form.Check.Label><small>{categoria.category.toUpperCase()}</small></Form.Check.Label>
                                                            </Form.Check>
                                                        ))}
                                                    </Form>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </Col>
                            </Row>
                        }
                    </Col>
                    <Col sm={tituloBusqueda === '' ? 9 : 11} xs={12}>
                        <Row className="align-items-center ms-3 me-3">
                            <Col className="carruselResponsive carruselMarca divFlechasUjueta pt-0 pb-0">
                                <Slider {...settingsMarcas}>
                                    {
                                        arrayMarcas.map((item, i) =>
                                            <Row key={i}>
                                                <Col className='imgMarcas' >
                                                    <img loading='lazy' fallback={<p>Cargando</p>} id={i} className="mx-auto img-fluid imgMarca" src={item.imagen} alt={item.nombre} width={'100%'} height={'100%'} />
                                                </Col>
                                            </Row>
                                        )
                                    }
                                </Slider>
                                <br></br>
                            </Col>
                        </Row>
                        {tituloBusqueda !== '' &&
                            <Row className='ps-5 mb-3'>
                                <Col xs={12} sm={9}>
                                    <b className='b_textProducto'>{tituloBusqueda === '' ? '' : 'Resultado de ' + tituloBusqueda}</b>
                                </Col>
                            </Row>
                        }
                        {isLoading ? (
                            <div className="d-flex justify-content-center" style={{ height: '35vh', alignItems: 'center' }}>
                                <Spinner animation="border" variant="warning" style={{ width: '100px', height: '100px' }} />
                            </div>
                        ) : (
                            <Row>
                                {
                                    filtroProductos.map((propiedades, id) => (
                                        <Col key={id} className='imgCatalogo'>
                                            <Container>
                                                <Card className="mx-auto cardProducto" style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)', borderRadius: '5px' }}>
                                                    <div className="divInfoAdicionalCard">
                                                        <div className='divNuevoUjueta'>BAJO PEDIDO</div>
                                                    </div>
                                                    <Link to={`/productSingleUjueta/${propiedades.sku}`} state={{ item_pedido: propiedades.sku }}>
                                                        <Card.Img loading='lazy' fallback={<p>Cargando</p>} variant="top" src={propiedades.thumbnail} className="imgProducto" id='imgProducto' />
                                                    </Link>
                                                    <Card.Body id="card">
                                                        <Card.Title style={{ lineHeight: '1', textTransform: 'uppercase' }}>
                                                            <Link to={`/productSingleUjueta/${propiedades.sku}`} state={{ item_pedido: propiedades.sku }} id='cardTitle'>
                                                                <b>{propiedades.name !== null &&
                                                                    <small>{propiedades.name.length > 100 ?
                                                                        propiedades.name.substring(0, 100) + '...' :
                                                                        propiedades.name}</small>
                                                                }</b>
                                                            </Link>
                                                        </Card.Title>
                                                        <Card.Text id='cardProducto'>
                                                            <small>REF: {propiedades.itemCode}</small>
                                                            <br></br>
                                                            <small>CÓDIGO: {propiedades.sku}</small>
                                                            <br></br>
                                                            <small>DISPONIBILIDAD: {parseInt(propiedades.onhand)}</small>
                                                        </Card.Text>
                                                        {
                                                            parseInt(propiedades.onhand) > 0
                                                                ?
                                                                <p className='textStock'></p>
                                                                :
                                                                <p className='textAgotado'>VALIDAR DISPONIBILIDAD</p>
                                                        }
                                                        <Row style={{ height: "40px" }}>
                                                            <Col md={12} lg={6} className="catalogoVertical">
                                                                <Row>
                                                                    <Col xs={12}>
                                                                        {parseFloat(propiedades.descuento) > 0 ?
                                                                            <b className="colorTexto precio">{formatoPesosColombianos.format(parseInt((propiedades.price * 1.19) * (1 - parseFloat(propiedades.descuento) / 100)))}</b>
                                                                            :
                                                                            <b className="colorTexto precio">{formatoPesosColombianos.format(parseInt(propiedades.price * 1.19))}</b>
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                        <Col xs={12} className={'divExclusivo text-danger'}>
                                                            <Truck /><strong><small> Entrega en 7 días hábiles</small></strong>
                                                        </Col>
                                                        <Card.Text className='conIva'><small>Con IVA incluido. COP</small></Card.Text>
                                                        <Button id='btnCatalogo' variant="outline-warning" style={{ width: '100%' }} disabled={parseInt(propiedades.onhand) <= 0} onClick={() => validacionAgregarProducto(propiedades)}>
                                                            <CartCheckFill />   Agregar al carrito
                                                        </Button>
                                                    </Card.Body>
                                                </Card>
                                            </Container>
                                        </Col>
                                    ))
                                }
                            </Row>)
                        }
                        <Row>
                            <Col className="mx-auto p-3" style={{ width: '300px' }}>
                                <Pagination className="mx-auto" style={{ width: '300px' }}>
                                    {paginaActual === 1 ? <div style={{ width: "40px" }}></div> : <Pagination.Prev onClick={() => handlePagination(paginaActual - 1)} />}
                                    {
                                        generatePageNumbers().map((item, i) =>
                                            <Pagination.Item key={i} onClick={() => handlePagination(item)} active={paginaActual === item}>{item}</Pagination.Item>
                                        )
                                    }
                                    {paginaActual === totalPaginas ? null : <Pagination.Next onClick={() => handlePagination(paginaActual + 1)} />}
                                </Pagination>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
            <div>
                <img style={{ width: '100%', maxWidth: '100%' }} src={imagenPublicidad + 'medios-pago.webp'} alt="medios de pago" />
            </div>
            <Footer />
            <Modal
                show={showModalAgregar}
                backdrop="static"
                keyboard={false}
                onHide={() => setShowModalAgregar(false)}
                centered
            >
                {
                    validacionAgregarCarrito
                        ? <Modal.Body>
                            <h4 className="mt-3 mb-3">{tituloMensaje} {validacionAgregarCarrito && objItem.descripcion}</h4>
                            <hr></hr>
                            <Row className="mx-auto justify-content-center text-center mb-2">
                                <Col sm={3}>
                                    ITEM: {objItem.item}
                                </Col>
                                <Col sm={3}>
                                    UM: {objItem.um}
                                </Col>
                            </Row>
                            <Row className="mx-auto justify-content-center text-center">
                                <Col sm={8}>
                                    <InputGroup className="mb-3">
                                        <Form.Control type="number" name="cantidad" placeholder="Cantidad" min="0" value={cantidad} onChange={(e) => setCantidad(e.target.value)} />
                                        <Button variant="outline-secondary" onClick={() => setCantidad(Math.max(1, cantidad - 1))}>-</Button>
                                        <InputGroup.Text className="custom-input-group-text">1</InputGroup.Text>
                                        <Button variant="outline-secondary" onClick={() => setCantidad(cantidad + 1)}>+</Button>
                                    </InputGroup>
                                </Col>
                            </Row>
                            <hr></hr>
                            <Row className="mx-auto justify-content-center text-center">
                                <Col sm={5}>
                                    <Button style={{ color: '#f7a708', borderColor: '#f7a708' }} variant="default btnAgregar" type="submit" onClick={registrarProductoCarrito}>Agregar al carrito</Button>
                                </Col>
                                <Col sm={3}>
                                    <Button variant="outline-secondary" type="button" onClick={() => setShowModalAgregar(false)}>Cancelar</Button>
                                </Col>
                            </Row>
                        </Modal.Body>
                        :
                        <Modal.Body>
                            <Row>
                                <Col sm={12}>
                                    Para agregar productos al carrito de compra se debe de iniciar sesión
                                    <br></br>
                                    <Link to='/inicioSesion' className='btn btn-outline-warning'>Iniciar sesión</Link>
                                </Col>
                            </Row>
                        </Modal.Body>
                }
            </Modal>
        </>
    );
};
export { CatalogoHUjueta };